<template>
  <div class="drupal hue page">
    <subpage-layout :theme="'light'" :name="this.$route.name">
      <template v-slot:hero-image>
        <img src="../assets/img/drupal_pattern.jpg" />
      </template>
      <template v-slot:hero-title>Drupal</template>
      <template v-slot:description>
        <h2>Drupal</h2>
        <p>
          I have been
          <strong>theming Drupal since 2014</strong>
          and have since learned a lot about its quirks and enormous
          scalability.
        </p>
        <p>
          Drupal is great at handling a
          <strong>
            multitude of languages, hundreds of pages of content and forms.
          </strong>
        </p>
        <p>
          Theming Drupal 7 and 8 is pretty much my day to day job, along with
          <strong>designing new content types</strong> and
          <strong>improving the UX and UI</strong> of existing pages and legacy
          content.
        </p>
        <p>
          Below you see screenshots of one of the recent
          <strong>
            relaunches of a multisite in Drupal 8 in several languages </strong
          >.
        </p>
      </template>
      <template v-slot:skills>
        <featured-temp :kind="'sm'">
          <template v-slot:featured-title>Skills</template>
          <template v-slot:default>
            <ul>
              <li>Drupal 8</li>
              <li>SCSS</li>
              <li>CSS</li>
              <li>Javascript</li>
              <li>JQuery</li>
            </ul>
          </template>
        </featured-temp>
      </template>

      <template v-slot:pics>
        <project-picture>
          <template v-slot:pic>
            <img src="../assets/img/apc_desktop.png" alt />
          </template>
          <template v-slot:label>
            <p>Here is a Drupal site screenshot detail</p>
          </template>
        </project-picture>

        <project-picture>
          <template v-slot:pic>
            <img src="../assets/img/form.png" alt />
          </template>
          <template v-slot:label>
            <p>Form detail styled Marketo Form in Drupal</p>
          </template>
        </project-picture>
        <project-picture>
          <template v-slot:pic>
            <img src="../assets/img/apc-cards.jpg" alt />
          </template>
          <template v-slot:label>
            <p>Content Type Cards Desktop</p>
          </template>
        </project-picture>

        <div class="mrow margin">
          <div class="mcol">
            <project-picture>
              <template v-slot:pic>
                <img src="../assets/img/apc-mobile.jpg" alt />
              </template>
              <template v-slot:label>
                <p>Screenshot Site Small Viewport</p>
              </template>
            </project-picture>
          </div>
          <div class="mcol">
            <project-picture>
              <template v-slot:pic>
                <img src="../assets/img/apc-cards-mobile.jpg" alt />
              </template>
              <template v-slot:label>
                <p>Content Type Cards Small</p>
              </template>
            </project-picture>
          </div>
        </div>
      </template>
    </subpage-layout>
  </div>
</template>

<script>
import subpageLayout from "@/components/SubpageLayout";
import featuredTemp from "@/components/FeaturedTemp";
import projectPicture from "@/components/ProjectPicture";

export default {
  name: "wordpress",
  components: {
    subpageLayout,
    featuredTemp,
    projectPicture,
  },
};
</script>

<style></style>
